export const setNotificationAction = (message, type = "success") => {
  return {
    type: "add_notification",
    payload: {
      type,
      content: message,
    },
  };
};
